<template>
  <div class="block">
    <el-pagination
      class="list_pagination"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="pageSize"
      :page-size="ps"
      layout="sizes, prev, pager, next"
      :total="TotalCount"
      v-if="TotalCount>0"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "pagination",
  data() {
    return {
      currentPage: 1,
      pageSize:this.type!=0?[60, 120, 240]:[12]
    };
  },
  props: {
    TotalCount: Number,
    ps:Number,
    type:Number
  },
  methods: {
    handleSizeChange(val) {
      document.documentElement.scrollTop = 0
      this.$emit('ps', val)
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      document.documentElement.scrollTop = 0
      this.$emit('pi', val)
      // console.log(`当前页: ${val}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.block{
  display: flex;
}
.list_pagination {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  margin: 20px 0;
  font-weight: 400;
}
.list_pagination .el-pagination__sizes {
  position: absolute;
  right: 0px;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  border: 1px solid #f0f0f0;
  background-color: #fff;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background-color: #f0f0f0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #5f6dae;
}

.el-pagination.is-background .el-pager li:not(.active):hover{
  color: #5f6dae;
}
</style>



// WEBPACK FOOTER //
// src/components/listpagination.vue